.subscription-info {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
  border-radius: 0.5rem;
  color: var(--tg-theme-text-color);
  background-color: var(--tg-theme-secondary-bg-color);
  cursor: default;

  &-icon {
    svg {
      width: 100%;
      height: 100%;
      object-fit: contain;

      g {
        fill: var(--tg-theme-subtitle-text-color) !important;
      }
    }
  }
}
